import React, { useState, useEffect } from 'react';
import './CardRackInfos.css';
import XClose from './x.svg';
import { useStore } from '../../store/useStore';
import site from '../../img/site.svg';

const CardRackInfos = (props) => {
    const { dashData } = useStore()
    const [localVar, setLocalVar] = useState(dashData);

    useEffect(() => {
        setLocalVar(dashData)
    }, [dashData])

    function temVirgula(str) {
        return str.includes(',');
      }
    
    return (
        <div className='card-rack-info'>
            <div className='card-rack-info-contaner'>
                <div className='card-rack-info-header'>
                    <h2>{props.rackSelected[0].rackName.split("/")[0]}</h2>
                    <img src={site} alt="site" style={{width:"24px", marginLeft:"8px"}}/>
                    <div className='card-rack-info-header-close'>
                        <img src={XClose} onClick={props.close} alt="icone botão fechar card"/>
                    </div>
                </div>

                <div className='card-rack-info-body'>
                    <tr className="tr-th-table-df">
                        <th>Status</th>
                        <th>Rack Name</th>
                        <th>Cage Name</th>
                        <th>Client</th>
                        <th>Occupation</th>
                        <th>Classification</th>
                        <th>Contracted Power</th>
                        <th>Power Consumed</th>
                        <th>Total PDU/SDU</th>
                    </tr>
                    {
                        props.rackSelected.map((rack, i) => {
                            return (
                                <div className='tr-th-table-df'>
                                    <td>
                                        <p>
                                            <h5 style={
                                                rack.reserved ? {backgroundColor:"#E89F17"}
                                                : rack.status ? {backgroundColor:"#B73D3D"} 
                                                : {backgroundColor:"#59975C"}}/>
                                            {rack.reserved ? 'Reserved' : rack.status ? 'Added' : 'Churned'}
                                        </p>
                                    </td>
                                    <td>{temVirgula(rack.rackName) ? rack.rackName.split(",")[0] : rack.rackName}</td>                                  
                                    <td>{rack.cage != null ? rack.cage : 'N/A'}</td>
                                    <td>{rack.clientName}</td>
                                    <td>{rack.ocupacao != '' ? rack.ocupacao : 'N/A' }</td>
                                    <td>{rack.classification != '' ? rack.classification : 'N/A' }</td>
                                    <td>{rack.potenciaContratada != '' ? rack.potenciaContratada : 'N/A' }</td>
                                    <td>{rack.potenciaConsumida != '' ? rack.potenciaConsumida : 'N/A' }</td>
                                    <td>
                                        {rack.pdu?.length > 0 ?
                                            <>
                                                {
                                                    rack.pdu.map((item) => {
                                                        return (
                                                            <div className='tr-th-table-df-pdu'>
                                                                <p>{item.name}:</p>
                                                                <p>{item.circuito}</p>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </> : <><p>N/A</p></>
                                        }  
                                    </td>
                                                                    
                                    
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default CardRackInfos